import { attributeUUID } from "../../../shared/attribute-uuid";

export const PARENT_TASK = {
    IEQA: "IEQA",
    PROFILING: "Profiling",
    CODING_QA: "Coding QA",
};

export const getParentTask = ({ uuid, sortGroupName = "" }) => {
    if (uuid === attributeUUID.imageApprovedAttr) {
        return PARENT_TASK.IEQA;
    }

    if (sortGroupName.includes("Profiling")) {
        return PARENT_TASK.PROFILING;
    }

    return PARENT_TASK.CODING_QA;
};

export const buildRejectEntry = ({ uuid, sortGroupName, isSupplierAttribute }) => ({
    open: false,
    isSupplierAttribute: !!isSupplierAttribute,
    parentTask: getParentTask({ uuid, sortGroupName }),
});

export const removeAttrEntry = (key) => (prevMap) => {
    const nextMap = new Map(prevMap);

    nextMap.delete(key);

    return nextMap;
};

export const setPendingAttrEntry = (key) => (prevMap) => new Map(prevMap).set(key, { open: true });

export const setRejectedAttrEntry =
    ({ uuid, sortGroupName, isSupplierAttribute }) =>
    (prevMap) =>
        new Map(prevMap).set(uuid, buildRejectEntry({ uuid, sortGroupName, isSupplierAttribute }));
